
import defaultLayoutComponent from '~pages/layouts/DefaultLayoutComponents.js'

let routeInfo = [
  {
    path: 'cart',
    name: 'Cart',
    components: Object.assign({}, defaultLayoutComponent, { content: () => import(/* webpackChunkName: "page_cart" */
      '~pages/contents/cart/Cart.vue') }
    ),
    beforeEnter: (to, from, next) => {
      console.log('cart root beforeEnter', to, from)
      next()
    },
    meta: {
      authorized: false,
      title: '장바구니'
    }
  }
]

export default routeInfo



// WEBPACK FOOTER //
// ./src/config/router/child/cart.js